var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{attrs:{"id":"products-list"}},_vm._l((_vm.products),function(prod){return _c('li',{staticClass:"prod_el"},[_c('ProductEn',{attrs:{"prod":prod}})],1)})),_vm._v(" "),(_vm.extra)?_c('ExtraTip',{attrs:{"extra":_vm.extra}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2be9ff4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product_group.vue
// module id = null
// module chunks = 